import React from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Skeleton, Grid, Stack, Box, Container } from "@mui/material";

import HeroSection from "../../components/common/HeroSection";
import HowToOpen from "./HowToOpen";
import BlockAccountCard from "./BlockAccountCard";
import { getOpenAccountPage } from "../../services/BlockOpenAccountPageService";

const OpenBlockAccount = () => {
  const { country_id, country_name } = useSelector((state) => state.auth || {});
  
  const { data: programData, isLoading: loading } = useQuery({
    queryKey: ["openAccountPage", country_id],
    queryFn: async () => {
      if (!country_id) return null;
      const res = await getOpenAccountPage(country_id);
      if (res?.data?.success && res?.data?.data) {
        return res.data.data;
      }
      return null;
    },
    enabled: !!country_id,
  });

  if (loading) {
    return (
      <Container
        sx={{
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="text" height={60} width="80%" />
            <Skeleton variant="text" height={30} width="90%" />
            <Skeleton variant="text" height={30} width="85%" />
            <Stack direction="row" spacing={2} mt={3}>
              <Skeleton variant="rounded" width={140} height={45} />
              <Skeleton variant="rounded" width={140} height={45} />
            </Stack>
            <Stack spacing={2} mt={3}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="75%" />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="rectangular" height={420} sx={{ borderRadius: 2 }} />
          </Grid>
        </Grid>
      </Container>
    );
  }

  if (!programData)
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <p>No block account data found for {country_name || "selected country"}.</p>
      </Box>
    );

  const heroTitle = programData.hero_section_title || "";
  const heroSubtitle = programData.hero_section_desc || "";
  const heroImage = programData.hero_section_image || "";
  const heroImageType = programData.hero_section_image_type || "image";
  const videos = programData.video_links || [];
  const about_title = programData.about_title || "";
  const about_desc = programData.about_desc || "";

  let points = [];
  try {
    if (programData.features?.length) {
      points = programData.features.map((item) => item.key);
    }
  } catch (e) {
    console.error("⚠️ Error parsing features:", e);
  }

  return (
    <>
      <HeroSection
        titleContent={heroTitle}
        subtitleContent={heroSubtitle}
        heroImage={heroImage}
        points={points}
        heroImageType={heroImageType}
      />
      <HowToOpen about_title={about_title} about_desc={about_desc} videos={videos} />
      <BlockAccountCard />
    </>
  );
};

export default OpenBlockAccount;
